export const setIsIntercomVisible = (isVisible: boolean) => {
  if (window.Intercom)
    window.Intercom('update', {
      hide_default_launcher: !isVisible,
    });
};
